import cx from 'classnames'
import { Text } from '@cinch-labs/design-system'
import styles from './admin-fee-button.module.css'
import skeletonStyles from '../../skeleton.module.css'
import { Env, readFromEnv } from '@cinch-nx/environments'

interface AdminFeeButtonProps {
  onAdminFeeClick?: () => void
  isPending?: boolean
}

const AdminFeeButton = ({
  onAdminFeeClick,
  isPending,
}: AdminFeeButtonProps) => {
  const adminFeeValueInPence = readFromEnv(Env.AdminFeeValue)

  const formatAdminFeeValue = () => {
    const adminFeeValue = Number.parseInt(adminFeeValueInPence) / 100
    if (!Number.isNaN(adminFeeValue)) {
      return `£${adminFeeValue}`
    }
    return ''
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    if (onAdminFeeClick) onAdminFeeClick()
  }

  const ariaLabel = `Includes ${formatAdminFeeValue()} admin fee. Find out more info`

  return (
    <Text
      fontSizeFixed="xs"
      element="button"
      disabled={isPending}
      onClick={handleClick}
      aria-label={ariaLabel}
      className={cx(styles['adminFeeInfoButton'], {
        [skeletonStyles['base']]: isPending,
        [skeletonStyles['active']]: isPending,
      })}
      data-testid="admin-fee"
    >
      Includes {formatAdminFeeValue()}{' '}
      <span className={cx(styles['adminFeeInfoButtonBreak'])}>admin fee</span>
    </Text>
  )
}

export default AdminFeeButton
